export default __webpack_public_path__ + "static/media/iconFaTrashDisable.33ad88fe.svg";